
import {createSelector} from 'reselect'

import {REPORT_MOON_IMAGES, REPORT_SCORE_RANGES} from '../constants'

const isSessionComplete = state => state.counselingSession.counselingSessionData.isComplete
const wasOriginallyComplete = state => !!state.counselingSession.unmodifiedApiResponse.isComplete
const factorsOption1 = counselingSessionData => counselingSessionData.factorsOption1
const factorsOption2 = counselingSessionData => counselingSessionData.factorsOption2
const roles = state => state.authorization.user.roles
const topThreeFactors = counselingSessionData => counselingSessionData.topThreeFactors
const finalWeight = state => state.counselingSession.counselingSessionData.finalWeight

export const isSessionDisabled = createSelector(
  [isSessionComplete, roles, wasOriginallyComplete],
  (isSessionComplete, roles, wasOriginallyComplete) => {
    if (!wasOriginallyComplete) {
      return false
    } else if (roles.indexOf('admin') === -1 && (isSessionComplete && wasOriginallyComplete)) {
      return true
    }
  }
)

export const selectedFactorIndices = createSelector(
  [factorsOption1, factorsOption2, topThreeFactors],
  (factorsOption1, factorsOption2, topThreeFactors) => {
    const indices = []
    const factors = factorsOption1.concat(factorsOption2)
    topThreeFactors.forEach(factor => {
      const index = factors.indexOf(factor)
      indices.push(index)
    })
    return indices
  }
)

export const willBypassComparingImportance = createSelector(
  [factorsOption1, factorsOption2],
  (factorsOption1, factorsOption2) => {
    const len = factorsOption1.length + factorsOption2.length
    return len === 1
  }
)

export const willBypassTopThreeFactors = createSelector(
  [factorsOption1, factorsOption2],
  (factorsOption1, factorsOption2) => {
    const len = factorsOption1.length + factorsOption2.length
    return len > 0 && len <= 3
  }
)

// same condition applies as comparing importance
export const willBypassOrderImportance = willBypassComparingImportance

export const getMoonImage = createSelector(
  [finalWeight],
  weight => {
    const moonIndex = REPORT_SCORE_RANGES.findIndex(max => weight <= max)

    return REPORT_MOON_IMAGES[moonIndex]
  }
)



// WEBPACK FOOTER //
// ./src/selectors/index.js